import React, { useState, useEffect } from "react";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import { FiSave } from "react-icons/fi";
import PageHeader from '../../components/shared/pageHeader/PageHeader'
import LeadsCreateHeader from '../../components/leadsViewCreate/LeadsCreateHeader'
import useTranslations from "../../hooks/useTranslations";
import useUserLanguage from "../../hooks/useUserLanguage";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

const RoleCreate = () => {
  const [roleName, setRoleName] = useState("");
  const [modules, setModules] = useState([]);
  const [saving, setSaving] = useState(false);
  const navigate = useNavigate();
  const language = useUserLanguage();
  const { translations } = useTranslations(language);
  const getText = (key, defaultValue) => translations[key] || defaultValue;

  useEffect(() => {
    fetchModules();
  }, []);

  const fetchModules = async () => {
    try {
      const token = localStorage.getItem("admin_token");
      const { data } = await axios.get(`${process.env.REACT_APP_API_BASE_URL}/api/modules`, {
        headers: { Authorization: `Bearer ${token}` },
      });

      /* Statik modüller */
      const staticModules = [
        { name: "Kullanıcılar",          key: "static_users" },
        { name: "Yönetici Hesapları",    key: "static_admin_accounts" },
        { name: "Url yönlendirme",       key: "static_url_redirect" },
        { name: "Mail Şablonları",       key: "static_mail_template" },
        { name: "Geliştirici Ayarları",  key: "static_developer_settings" },
        { name: "Roller",                key: "static_roles" },
        { name: "Tanımlar",              key: "static_definitions" },
        { name: "Modüller",              key: "static_modules" },
        { name: "Navigate Menü",         key: "static_navigate" },
        { name: "Versiyon",              key: "static_version" },
        { name: "Yardım Merkezi",        key: "static_help_center" },
      ];

      /* Ortak izin alanlarının başlangıç değeri */
      const blankPerms = {
        full_access: false,
        sort_permission: false,
        view_permission: false,
        create_permission: false,
        edit_permission: false,
        status_permission: false,
        delete_permission: false,
        trash_permission: false,
      };

      /* Dinamik + statik birleştir */
      setModules([
        ...data.map((m) => ({ ...m, key: null,   ...blankPerms })),
        ...staticModules.map((m) => ({ id: null, ...m,   ...blankPerms })),
      ]);
    } catch (e) {
      console.error("Modüller alınamadı:", e);
      setModules([]);
    }
  };

  const handleCheckboxChange = (i, field) => {
    setModules((prev) => {
      const next = [...prev];
      next[i] = { ...next[i], [field]: !next[i][field] };

      /* Full access tüm alt izinleri etkiler ama key’i BOZMAYACAK! */
      if (field === "full_access") {
        const val = next[i].full_access;
        Object.keys(next[i]).forEach((k) => {
          if (!["id", "name", "key", "module_id"].includes(k)) {
            next[i][k] = val;
          }
        });
      }
      return next;
    });
  };

  const handleSaveRole = async () => {
    if (!roleName.trim()) {
      alert("Rol adı boş olamaz!");
      return;
    }

    setSaving(true);
    try {
      const token = localStorage.getItem("admin_token");

      // 1️Yeni rolü oluştur
      const roleResponse = await axios.post(
        `${process.env.REACT_APP_API_BASE_URL}/api/roles`,
        { role_name: roleName },
        { headers: { Authorization: `Bearer ${token}` } }
      );

      console.table(
        modules
          .filter(m => m.key)     // sadece statikler
          .map(m => ({ key: m.key, sort: m.sort_permission }))
      );

      const roleId = roleResponse.data.role.id;
      console.log("Yeni Rol Eklendi:", roleResponse.data);

      // Rolün yetkilerini ekle
      const payload = {
        role_id: roleId,
        permissions: modules.map((modul) => ({
          module_id: modul.id || null,        // id varsa gönder, yoksa null
          module_key: modul.key || null,       // key varsa gönder, yoksa null
          role_id: roleId,
          full_access: modul.full_access,
          sort_permission: modul.sort_permission,
          view_permission: modul.view_permission,
          create_permission: modul.create_permission,
          edit_permission: modul.edit_permission,
          status_permission: modul.status_permission,
          delete_permission: modul.delete_permission,
          trash_permission: modul.trash_permission,
        })),
      };

      console.log("📤 Gönderilen Yetki Payload:", JSON.stringify(payload, null, 2));

      await axios.post(`${process.env.REACT_APP_API_BASE_URL}/api/permissions`, payload, {
        headers: { Authorization: `Bearer ${token}` },
      });

      toast.success(" Rol ve Yetkileri Başarıyla Eklendi!", {
        position: "top-right",
        autoClose: 3000,
      });
  
      // navigate("/admin/roles");
    } catch (error) {
      console.error("Rol eklenirken hata:", error.response?.data || error);
      alert("Rol eklenirken hata oluştu!");
    }
    setSaving(false);
  };
  return (
    <div className="page-content p-4">
      <ToastContainer />
      <div className="card stretch stretch-full function-table">
        <div className="card-body p-4">
          <h3 className="page-title">{getText("ROLE_CREATE_TITLE")}</h3>
          <div className="panel-body p-4">
            <div className="mb-3">
              <label className="form-label">{getText("ROLE_NAME_LABEL")}</label>
              <input
                type="text"
                className="form-control"
                value={roleName}
                onChange={(e) => setRoleName(e.target.value)}
                placeholder={getText("ROLE_NAME_PLACEHOLDER")}
              />
            </div>
            {modules.length > 0 ? (
              <div className="table-responsive">
                <table className="table table-hover">
                  <thead>
                    <tr>
                      <th style={{ width: "30%" }}>{getText("MODULE_NAME")}</th>
                      <th className="text-center" style={{ width: "10%" }}>{getText("PERMISSION_FULL")}</th>
                      <th className="text-center" style={{ width: "10%" }}>{getText("PERMISSION_LIST")}</th>
                      <th className="text-center" style={{ width: "10%" }}>{getText("PERMISSION_PREVIEW")}</th>
                      <th className="text-center" style={{ width: "10%" }}>{getText("PERMISSION_ADD")}</th>
                      <th className="text-center" style={{ width: "10%" }}>{getText("PERMISSION_EDIT")}</th>
                      <th className="text-center" style={{ width: "10%" }}>{getText("PERMISSION_STATUS")}</th>
                      <th className="text-center" style={{ width: "10%" }}>{getText("PERMISSION_DELETE")}</th>
                      <th className="text-left" style={{ width: "10%" }}>{getText("PERMISSION_TRASH")}</th>
                    </tr>
                  </thead>
                  <tbody>
                    {modules.map((modul, index) => (
                      <tr key={modul.id || `module-${index}`}>
                        <td>{modul.name}</td>
                        {["full_access", "sort_permission", "view_permission", "create_permission", "edit_permission", "status_permission", "delete_permission", "trash_permission"].map((permKey) => (
                          <td key={`${modul.id}-${permKey}`} className="text-center">
                            <label className="switch">
                              <input
                                type="checkbox"
                                checked={modul[permKey]}
                                onChange={() => handleCheckboxChange(index, permKey)}
                              />
                              <span className="slider round"></span>
                            </label>
                          </td>
                        ))}
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            ) : (
              <p className="text-center p-3">{getText("MODULE_LOADING")}</p>
            )}
            <div className="d-flex justify-content-center mt-3">
              <button className="btn btn-primary" onClick={handleSaveRole} disabled={saving}>
                <FiSave className="me-2" />
                {getText("SAVE_BTN")}
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default RoleCreate;
